import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Loading = () => {
  const [text, setText] = useState("주파수 동기화 중...");

  useEffect(() => {
    const messages = [
      "심연의 신호를 포착했습니다...",
      "본능의 궤적을 추적하고 있습니다...",
      "전설의 형상이 실체화됩니다!"
    ];
    let i = 0;
    const interval = setInterval(() => {
      if (i < messages.length) {
        setText(messages[i]);
        i++;
      }
    }, 1200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ 
      backgroundColor: '#00050A', // 더 깊은 블랙으로 몰입감 선사
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      color: 'white',
      overflow: 'hidden'
    }}>
      
      {/* 고퀄리티 에픽 나침반 엔진 */}
      <div style={{ position: 'relative', width: '320px', height: '320px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        
        {/* 1. 바깥 테두리 고리 (신비로운 푸른 빛) */}
        <motion.div 
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          style={{ 
            position: 'absolute', width: '100%', height: '100%',
            border: '1px double rgba(96, 165, 250, 0.15)', borderRadius: '50%',
            boxShadow: 'inset 0 0 20px rgba(96, 165, 250, 0.1)'
          }}
        />

        {/* 2. 에픽 룬/눈금 레이어 (반대로 회전하며 신비감 조성) */}
        <motion.div 
          animate={{ rotate: -360 }}
          transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          style={{ 
            position: 'absolute', width: '85%', height: '85%',
            border: '1px dashed rgba(255, 255, 255, 0.1)', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >
           {/* 내부에 작은 원 추가 */}
           <div style={{ width: '95%', height: '95%', border: '1px solid rgba(255, 215, 0, 0.05)', borderRadius: '50%' }} />
        </motion.div>

        {/* 3. 메인 황금 나침반 바늘 (에픽 회전 연출) */}
        <motion.div 
          animate={{ 
            rotate: [0, 180, 1080, 2160, 3600], 
            scale: [1, 1.1, 1] 
          }} 
          transition={{ duration: 4, ease: [0.45, 0.05, 0.55, 0.95] }}
          style={{ 
            position: 'absolute',
            width: '2px',
            height: '160px', 
            background: 'linear-gradient(to top, transparent 50%, #FFD700 50%)',
            boxShadow: '0 0 20px #FFD700',
            zIndex: 10,
            filter: 'drop-shadow(0 0 5px gold)'
          }}
        />

        {/* 4. 중앙 마력 코어 (강한 후광) */}
        <motion.div 
          animate={{ scale: [1, 1.3, 1], opacity: [0.6, 1, 0.6] }}
          transition={{ repeat: Infinity, duration: 2 }}
          style={{ 
            position: 'absolute', width: '14px', height: '14px', backgroundColor: '#FFF', 
            borderRadius: '50%', zIndex: 20, 
            boxShadow: '0 0 20px #FFF, 0 0 40px #60A5FA, 0 0 60px #60A5FA'
          }} 
        />

        {/* 5. 파동 스캔 효과 (동심원이 퍼져 나감) */}
        {[1, 2, 3].map((i) => (
          <motion.div 
            key={i}
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 2, opacity: 0 }}
            transition={{ duration: 2, repeat: Infinity, delay: i * 0.6 }}
            style={{ 
              position: 'absolute', width: '100%', height: '100%',
              border: '1px solid rgba(96, 165, 250, 0.4)', borderRadius: '50%'
            }}
          />
        ))}
      </div>

      {/* 텍스트 영역 */}
      <div style={{ marginTop: '80px', textAlign: 'center', zIndex: 30 }}>
        <motion.div
          animate={{ opacity: [0.3, 0.8, 0.3], letterSpacing: ['4px', '8px', '4px'] }}
          transition={{ duration: 3, repeat: Infinity }}
          style={{ 
            fontSize: '12px', color: '#60A5FA', 
            textTransform: 'uppercase', marginBottom: '15px', fontWeight: 'bold'
          }}
        >
          Resonating with Spirit
        </motion.div>
        
        <AnimatePresence mode="wait">
          <motion.div 
            key={text}
            initial={{ opacity: 0, y: 10, filter: 'blur(5px)' }}
            animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            exit={{ opacity: 0, y: -10, filter: 'blur(5px)' }}
            transition={{ duration: 0.5 }}
            style={{ fontSize: '1.2rem', fontWeight: '300', color: '#E5E7EB', minHeight: '1.5em' }}
          >
            {text}
          </motion.div>
        </AnimatePresence>
      </div>

    </div>
  );
};

export default Loading;